////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskDiagnostic = {
	[ActionsTypes.RESET_DATA_KIOSK_DIAGNOSTIC]: (state) => {
		return update(state, {
			kioskDiagnostic: {
				items: {
					$set: [],
				},
				header: {
					$set: {},
				},
				pageTitleParam: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_DIAGNOSTIC]: (state) =>
		update(state, {
			kioskDiagnostic: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
				pageTitleParam: {
					$set: {},
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_DIAGNOSTIC_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			kioskDiagnostic: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
				pageTitleParam: {
					$set: {
						owner: payload.data.headerParam.owner,
						kioskCode: payload.data.headerParam.kioskCode,
						kioskName: payload.data.headerParam.kioskName,
					},
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_DIAGNOSTIC_FAILURE]: (state, payload) =>
		update(state, {
			kioskDiagnostic: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default kioskDiagnostic
